<template>
	<div v-show="visible" :class="{ fullscreen }" class="vue-pixellot-loading">
		<loading-fullscreen v-if="fullscreen" />
		<loading-circle v-else-if="circle" />
		<loading-regular v-else />
	</div>
</template>

<script>
import LoadingFullscreen from './loading-fullscreen'
import LoadingCircle from './loading-circle'
import LoadingRegular from './loading-regular'

export default {
	name: 'Loading',
	components: { LoadingFullscreen, LoadingCircle, LoadingRegular },
	data: () => ({ visible: false, fullscreen: false, circle: false }),
	methods: {
		show () {
			this.visible = true
		},
		hide () {
			this.visible = false
		},
		setFullscreen (value) {
			this.fullscreen = value
		},
		setCircle (value) {
			this.circle = value
		}
	}
}
</script>

<style lang="scss">
	.vue-pixellot-loading {
		position: absolute;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0.75;
		background: rgba(#F5F5F5, 0.7);
		display: flex;
		align-items: center;
		justify-content: center;

		&.fullscreen {
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 999;
			background-color: #F5F5F5;
		}
	}
</style>
